import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-demo-company',
  templateUrl: './update-demo-company.component.html',
  styleUrls: ['./update-demo-company.component.css']
})
export class UpdateDemoCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/update-demo-company/update-demo-company.component.ts